import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppRouter from "./AppRouter";
import PublicRouter from "./PublicRouter";
import PrivateRouter from "./PrivateRouter";
import Login from "../pages/Login";
import RecoverPassword from "../pages/RecoverPassword";
import RegisterInvitedUser from "../pages/RegisterInvitedUser";
import ResetPassword from "../pages/ResetPassword";
import TyC from "../pages/extras/TyC";

const AuthRouter = () => {
  return (
    <Router>
      <Routes>
        <Route
          end
          path="/login"
          element={
            <PublicRouter>
              <Login />
            </PublicRouter>
          }
        />
        <Route
          end
          path="/login/reset"
          element={
            <PublicRouter>
              <RecoverPassword />
            </PublicRouter>
          }
        />
        <Route
          end
          path="/login/forgot/:token"
          element={
            <PublicRouter>
              <ResetPassword />
            </PublicRouter>
          }
        />
        <Route
          end
          path="/register/invited/:id"
          element={
            <PublicRouter>
              <RegisterInvitedUser />
            </PublicRouter>
          }
        />
        <Route end path="/tyc" element={<TyC />} />
        <Route
          path="*"
          element={
            <PrivateRouter>
              <AppRouter />
            </PrivateRouter>
          }
        />
      </Routes>
    </Router>
  );
};

export default AuthRouter;
